import { render, staticRenderFns } from "./AboutBody.vue?vue&type=template&id=54e98036&"
import script from "./AboutBody.vue?vue&type=script&lang=js&"
export * from "./AboutBody.vue?vue&type=script&lang=js&"
import style0 from "./AboutBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports